import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { useRoute, useRouter, RouteLocationRaw } from "vue-router";
import { ArrowLeftIcon } from "@heroicons/vue/outline";
import Button from "./Button.vue";
import { t } from "@/i18n";


export default /*#__PURE__*/_defineComponent({
  props: {
    to: null,
    useHistory: { default: true }
  },
  setup(__props: any) {

const props = __props as { to: RouteLocationRaw, useHistory: boolean }

/* global defineProps, withDefaults */

const router = useRouter();
const route = useRoute();

function goBack() {
  const previous = router.options.history.state.back;
  if (
    props.useHistory !== false &&
    typeof previous === "string" &&
    previous.startsWith("/") &&
    !previous.startsWith("//")
  ) {
    const target = router.resolve(previous);
    if (
      target.meta.auth === true &&
      target.name !== "NotFound" &&
      target.fullPath !== route.fullPath
    ) {
      router.back();
      return;
    }
  }
  router.push(props.to);
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(Button, {
    type: "button",
    variant: "default",
    class: "gap-2",
    onClick: goBack
  }, {
    default: _withCtx(() => [
      _createVNode(_unref(ArrowLeftIcon), {
        class: "h-5 w-5",
        "aria-hidden": "true"
      }),
      _createTextVNode(" " + _toDisplayString(_unref(t)("common.back")), 1)
    ]),
    _: 1
  }))
}
}

})